import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

// Async thunk for fetching country code data
export const fetchCountryCode = createAsyncThunk(
  "country/fetchCountryCode",
  async (thunkAPI) => {
    try {
      const response = await APIKit().get(
        `${API_END_POINTS.fetchcountryCodes}`
      );

      // If API returns 200 or 400 with 'No data found!', handle it as success
      if (
        response?.status === 200 ||
        (response?.status === 400 && response?.data?.message === "No data found!")
      ) {
        return response?.data; // Return response data to be handled in 'fulfilled'
      } else {
        // Reject if the response is not as expected
        return thunkAPI.rejectWithValue(response?.data || "Unknown error");
      }
    } catch (error) {
      // Handle API or network errors
      return thunkAPI.rejectWithValue(error.response?.data || "Server error");
    }
  }
);

// Initial state
const initialState = {
  data: null,  // Consider initializing as an empty array or object if appropriate
  loading: false,
  error: null,
};

// Country slice definition
const countrySlice = createSlice({
  name: "country",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCountryCode.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error while loading
      })
      .addCase(fetchCountryCode.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // Store fetched data
      })
      .addCase(fetchCountryCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store error message
      });
  },
});

export default countrySlice.reducer;
